import { MAX_ADMIN_TASK_LOCATION_RADIUS, MIN_ADMIN_TASK_LOCATION_RADIUS, } from '../../app.config.vars/stored';
export const validationErrorMessageTranslationKeys = {
    isEmpty: 'validation.is_not_empty',
    isNotUnique: 'validation.is_not_unique',
    playerNameContainsDisallowedCharacters: 'validation.player_name_allowed_characters',
    isTooShort: 'validation.is_too_short',
    isTooLong: 'validation.is_too_long',
    playerNameIsNotUnique: 'validation.player_name_is_not_unique',
    answerIsNotSelected: 'validation.answer_is_not_selected',
    fileIsNotSelected: 'validation.file_is_not_selected',
    invalidEmail: 'validation.invalid_email',
    isDifferent: 'validation.different_values',
    invalidMinute: 'validation.invalid_minute',
    emptyMultipleSelect: 'validation.empty_multiple_select',
    invalidCoordinate: 'validation.invalid_coordinate',
    invalidRadius: 'validation.invalid_radius',
    isZero: 'validation.is_zero',
    isNegative: 'validation.is_negative',
    isNotInteger: 'validation.is_not_integer',
    greaterThanMaxValue: 'validation.greater_than_max_value',
    invalidInternalTitle: 'validation.invalid_internal_title',
};
export const isNotEmpty = (value) => value
    ? null
    : {
        messageTranslationKey: validationErrorMessageTranslationKeys.isEmpty,
    };
export const isNotEmptyRTE = (value) => {
    const cleanValue = value
        .replace(/<p><br><\/p>/gi, '')
        .replace(/&nbsp;/g, '')
        .trim();
    return cleanValue.length
        ? null
        : {
            messageTranslationKey: validationErrorMessageTranslationKeys.isEmpty,
        };
};
export const isUnique = (value, context) => {
    const existingValues = context?.existingValues || [];
    if (!existingValues.length) {
        return null;
    }
    const isMatch = existingValues.find((existingValue) => {
        return existingValue.toLowerCase() === value.toLowerCase();
    });
    if (isMatch) {
        return {
            messageTranslationKey: validationErrorMessageTranslationKeys.playerNameIsNotUnique,
        };
    }
    return null;
};
export const hasMinLength = (minLength) => (value) => {
    return value
        ? value.length >= minLength
            ? null
            : {
                messageTranslationKey: validationErrorMessageTranslationKeys.isTooShort,
                variableToUseInMessage: { minLength },
            }
        : null;
};
export const hasMaxLength = (maxLength) => (value) => {
    return value
        ? value.length <= maxLength
            ? null
            : {
                messageTranslationKey: validationErrorMessageTranslationKeys.isTooLong,
                variableToUseInMessage: { maxLength },
            }
        : null;
};
export const hasOnlyAllowedCharacters = (value, context) => {
    const allowedCharsRegex = context?.allowedCharsRegex || null;
    if (allowedCharsRegex) {
        return allowedCharsRegex.test(value)
            ? null
            : {
                messageTranslationKey: validationErrorMessageTranslationKeys.playerNameContainsDisallowedCharacters,
            };
    }
    else {
        return null;
    }
};
export const isValidEmail = (value) => {
    const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    return regex.test(value)
        ? null
        : { messageTranslationKey: validationErrorMessageTranslationKeys.invalidEmail };
};
export const isTheSame = (originalValue) => (value) => {
    return value.trim() === originalValue.trim()
        ? null
        : { messageTranslationKey: validationErrorMessageTranslationKeys.isDifferent };
};
export const isValidMinutes = (maxMinutes) => (value) => {
    const num = +value;
    return Number.isInteger(num) && num > 0 && num <= maxMinutes
        ? null
        : {
            messageTranslationKey: validationErrorMessageTranslationKeys.invalidMinute,
            variableToUseInMessage: { maxMinutes },
        };
};
export const isAnswerSelected = (isSelected) => {
    return isSelected
        ? null
        : { messageTranslationKey: validationErrorMessageTranslationKeys.answerIsNotSelected };
};
export const isSelected = (type) => (isSelected) => {
    return isSelected
        ? null
        : {
            messageTranslationKey: type === 'single'
                ? validationErrorMessageTranslationKeys.isEmpty
                : validationErrorMessageTranslationKeys.emptyMultipleSelect,
        };
};
export const isFileUploaded = (isSelected) => {
    return isSelected
        ? null
        : { messageTranslationKey: validationErrorMessageTranslationKeys.fileIsNotSelected };
};
export const isValidLatitude = (value) => {
    const num = +value;
    return !isNaN(num) && num >= -90 && num <= 90
        ? null
        : {
            messageTranslationKey: validationErrorMessageTranslationKeys.invalidCoordinate,
        };
};
export const isValidLongitude = (value) => {
    const num = +value;
    return !isNaN(num) && num >= -180 && num <= 180
        ? null
        : {
            messageTranslationKey: validationErrorMessageTranslationKeys.invalidCoordinate,
        };
};
export const isValidRadius = (value) => {
    const num = +value;
    return Number.isInteger(num) &&
        (num === 0 || (num >= MIN_ADMIN_TASK_LOCATION_RADIUS && num <= MAX_ADMIN_TASK_LOCATION_RADIUS))
        ? null
        : {
            messageTranslationKey: validationErrorMessageTranslationKeys.invalidRadius,
        };
};
export const isNotZero = (value) => {
    const num = +value;
    return num !== 0
        ? null
        : {
            messageTranslationKey: validationErrorMessageTranslationKeys.isZero,
        };
};
export const isNotNegative = (value) => {
    const num = +value;
    return num >= 0
        ? null
        : {
            messageTranslationKey: validationErrorMessageTranslationKeys.isNegative,
        };
};
export const isInteger = (value) => {
    const num = +value;
    return Number.isInteger(num)
        ? null
        : {
            messageTranslationKey: validationErrorMessageTranslationKeys.isNotInteger,
        };
};
export const exceedsMaxValue = (maxValue) => (value) => {
    const num = +value;
    return num <= maxValue
        ? null
        : {
            messageTranslationKey: validationErrorMessageTranslationKeys.greaterThanMaxValue,
            variableToUseInMessage: { maxValue },
        };
};
export const hasTranslations = (value, context) => {
    if (value) {
        const translations = context?.translations;
        return Object.values(translations).every((value) => value.trim() !== '')
            ? null
            : { messageTranslationKey: validationErrorMessageTranslationKeys.playerNameIsNotUnique };
    }
    else {
        return null;
    }
};
